

































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditMembre from '@/components/compte/edit/EditMembre.vue'
import { getDefaultAloUser, AloUser } from '@/models/alo/AloUser'

@Component({
  name: 'ReadFamille',    
   props: {
    users:{      
      type:Array,
      default:() => []      
    },    
    famId:{
      type:Number,
      default:0
    },  
    famActId:{
      type:Number,
      default:0
    },   
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{EditMembre}
})
export default class ReadFamille extends Vue {
  private users!: Array<AloUser>
  private famActId!:number
  private famId!:number
  private loading!:boolean


  get membres(){
    return this.users.map(m => {
      return {
        ...m,
        class: m?.actId == this.famActId?'main':''
      }
    })
  }

   private headersMembres = [            
    { text: '', value: 'usrEmail', width:50},           
    { text: 'Nom', value: 'usrNom' },           
    { text: 'Prénom', value: 'usrPrenom' },      
    { text: 'Tél', value: 'usrTel', width:130 },      
    { text: 'Anniversaire', value: 'usrDatbirth', width:160 },        
    { text: '', value: 'action', width:50 },        
  ]

  addMembre(){
    (this.$refs.editMembre as EditMembre).edit({...getDefaultAloUser(),famId:this.famId}) 
  }

  editMembre(membre:AloUser){
    (this.$refs.editMembre as EditMembre).edit(membre) 
  }

  onCopy(e:any) {
    this.$store.myActions.UI_ADD_SNACK_MESSAGE(`${e.text} copié dans le presse papier !`)
  }
}
